import { PDFDownloadLink } from "@react-pdf/renderer";
import Preview from "./Preview";
import { useResumeData } from "../hooks/useResumeData";
import { useSelector } from "react-redux";
import { State } from "../props/State.props";

const DownloadPDF = () => {
  const [resumeData] = useResumeData();
  const getFontFamily = useSelector((state: State) => state.getFontFamily);
  const theme: string = useSelector((state: State) => state.getTheme);

  const date = new Date();

  const getTheme: { [key: string]: { [key: string]: string | undefined } } = {
    dark: {
      bg: "#191D20",
      fg: "#E3E3E3",
    },
    light: {
      bg: "#E3E3E3",
      fg: "#191D20",
    },
  };

  return (
    <>
      <PDFDownloadLink
        document={
          <Preview
            resumeData={resumeData}
            date={date}
            theme={getTheme[theme]}
            font={getFontFamily}
          />
        }
        fileName={`${resumeData.name.replace(/ /gi, "_")}_${date
          .toDateString()
          .replace(/ /gi, "_")}_${date.getTime()}`}
          className={`flex items-center gap-3 text-sm font-semibold rounded-lg bg-[#2a3035] text-dark-fg cursor-pointer mb-2 p-4 text-center`}
          >
        <i className="fa fa-download" />
        <div className="text-left">Download Resume</div>
      </PDFDownloadLink>
    </>
  );
};

export default DownloadPDF;
